var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSort2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7,2.59l4.71,4.71-1.41,1.41-2.29-2.29v13.59h-2V6.41l-2.29,2.29-1.41-1.41L7,2.59Zm13.29,12.71l-2.29,2.29V4h-2v13.59l-2.29-2.29-1.41,1.41,4.71,4.71,4.71-4.71-1.41-1.41Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSort2);
export default __webpack_public_path__ + "static/1773309961/media/icon-sort2.fcd089ab97209a5920534a74c7fb93ea.svg";
export { ForwardRef as ReactComponent };